<template>
   <nav-bar title="通知公告详细" />
    <Content :bottom="0" >
      <Loading
        v-if="showLoading"
        :isLoading="isLoading"
        @reload="getDataLoading"
      />
      <div class="news">
        <div class="news-title">{{news.newsTitle}}</div>
        <div class="news-time">{{news.createtime}}</div>
        <div class="news-img">
          <img :src="news.thumUrl"  alt="">
        </div>
        <div class="news-content" v-html="news.newsBody || ''"></div>
      </div>
    </Content>
</template>

<script>
import { ref } from 'vue'
import { getDetail } from '@/api/viewGasCylinder'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
export default {
  name: 'AnnouncementDetail',
  props: ['id'],
  setup (props) {
    const news = ref({})
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(getDetail, (data) => {
      news.value = data
    }, props.id)
    getDataLoading()
    return {
      getDataLoading, showLoading, isLoading, news
    }
  }
}
</script>

<style lang="scss" scoped>
.news {
  padding: 16px;
  .news-title {
    font-size: 16px;
    text-align: center;
    font-weight: 600;
    border-bottom: 1px dotted #ddd;
    padding-bottom: 16px;
  }
  .news-time {
    font-size: 12px;
    color: #ccc;
    margin: 16px 0;
  }
  .news-img {
    color: #666;
    img {
      width: 100%;
    }
  }
  .news-content {
    color: #666;
    font-size: 14px;
    line-height: 24px;
  }
}
</style>
